import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-leo-e1-target",
  "use": "icon-leo-e1-target-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-leo-e1-target\">\r\n<g transform=\"translate(-17.329 -17.329) scale(1.033846)\">\r\n<path d=\"M512 128a384 384 0 1 1 0 768 384 384 0 0 1 0-768zm0 96a288 288 0 1 0 0 576 288 288 0 0 0 0-576zm0 96a192 192 0 1 1 0 384 192 192 0 0 1 0-384zm0 96a96 96 0 1 0 0 192 96 96 0 0 0 0-192z\" />\r\n  <path d=\"M480 96h64v128h-64V96zm0 704h64v128h-64V800zM96 480h128v64H96v-64zm704 0h128v64H800v-64z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/leo-e1-target.svg
// module id = zt2j
// module chunks = 491